import { GET_MAKE_REQUEST, GET_MAKE_SUCCESS, GET_MAKE_FAIL, 
    GET_MODEL_REQUEST, GET_MODEL_SUCCESS, GET_MODEL_FAIL, 
    GET_INSURANCECOMPANY_REQUEST, GET_INSURANCECOMPANY_SUCCESS, GET_INSURANCECOMPANY_FAIL,
    GET_PRODUCTLIST_REQUEST, GET_PRODUCTLIST_SUCCESS, GET_PRODUCTLIST_FAIL,
    GET_VEHICLE_REQUEST, GET_VEHICLE_SUCCESS, GET_VEHICLE_FAIL } from '../types/getApiTypes'
import Axios from 'axios'
import APP_CONSTANT from '../../config/constants'

export const getInsuranceCompany = () => async (dispatch) => {
    dispatch({ type: GET_INSURANCECOMPANY_REQUEST });
    try {
        let token = localStorage.getItem('apiToken')
        let customerNo = localStorage.getItem('customerNo')
        let userId = localStorage.getItem('userId')
            
        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/insuranceCompany/?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_INSURANCECOMPANY_SUCCESS, payload: data });
        
        // console.log("====Data", data)
    } catch (error) {
        dispatch({ type: GET_INSURANCECOMPANY_FAIL, payload: error.message })
    }
}

export const getModel = () => async (dispatch) => {
    dispatch({ type: GET_MODEL_REQUEST });
    try {
        
        let token = localStorage.getItem('apiToken')
        let customerNo = localStorage.getItem('customerNo')
        let userId = localStorage.getItem('userId')
        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/vehicleModel/?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_MODEL_SUCCESS, payload: data });

    } catch (error) {
        dispatch({ type: GET_MODEL_FAIL, payload: error.message })
    }
}

export const getMake = () => async (dispatch) => {
    dispatch({ type: GET_MAKE_REQUEST });
    try {
        
        let token = localStorage.getItem('apiToken');
        let customerNo = localStorage.getItem('customerNo');
        let userId =  localStorage.getItem('userId');

        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/vehicleMake/?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_MAKE_SUCCESS, payload: data });

    } catch (error) {
        dispatch({ type: GET_MAKE_FAIL, payload: error.message })
    }
}


export const getProduct = (id) => async (dispatch) => {
    dispatch({ type: GET_PRODUCTLIST_REQUEST });
    try {
 
        let token = localStorage.getItem('apiToken')
        let customerNo = localStorage.getItem('customerNo')
        let  userId =  localStorage.getItem('userId')

        const { data } = await Axios.get(`${APP_CONSTANT.BASE_URL}masters/psLineItem?customerNumber=${customerNo}&userId=${userId}`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_PRODUCTLIST_SUCCESS, payload: data });
        
        // console.log("====Data", data)
    } catch (error) {
        dispatch({ type: GET_PRODUCTLIST_FAIL, payload: error.message })
    }
}

export const getVehicle = () => async (dispatch) => {
    dispatch({ type: GET_VEHICLE_REQUEST });
    try {
        const headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customerNumber": localStorage.getItem('customerNo'),
            "userId": localStorage.getItem('userId'),
            "vehicleId": '',
            "searchString": "",
        }
        
        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}masters/vehicleMaster`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*" 
            }
        });
        dispatch({ type: GET_VEHICLE_SUCCESS, payload: data });
        
        // console.log("====VehicleData", data)
    } catch (error) {
        dispatch({ type: GET_VEHICLE_FAIL, payload: error.message })
    }
}